import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { t } from 'utils/translates';

import {
  selectQueryParams,
  changeQueryParams,
  sendRequest
} from 'mt-react-common/common/reducers/list/reducer';

const faqContentsSearchListRN = 'faqContents.lists.faqContentsSearchList';

// eslint-disable-next-line react/prefer-stateless-function
class SearchForm extends Component {
  handleSubmit = async event => {
    event.preventDefault();
    if (this.props.selectQueryParams.content.length === 0) {
      this.context.router.history.push('/help/reference-information');
    }
    this.props.sendRequest();
  };

  render() {
    return (
      <div className="panel panel-default">
        <div className="panel-body">
          <h1 className="page-header hidden-xs">
            <i className="fa fa-question-circle fa-lg" /> {t('Помощь')}
          </h1>
          <form className="form-inline" onSubmit={this.handleSubmit}>
            <div className="form-group pull-right visible-sm m-b-0">
              <button
                className="btn btn-default"
                data-toggle="sidebar-r"
                type="button"
              >
                <span>{t('Меню')}</span>
              </button>
            </div>
            <div className="form-group form-group-block m-b-0">
              <label className="control-label sr-only" htmlFor="content">
                {t('Поиск по справке')}
              </label>
              <div className="input-group">
                <input
                  className="form-control"
                  id="content"
                  placeholder={t('Поиск по справке')}
                  type="text"
                  value={this.props.selectQueryParams.content}
                  onChange={e => {
                    this.props.changeQueryParams({
                      content: e.target.value
                    });
                  }}
                />
                <span className="input-group-btn">
                  <button
                    className="btn btn-default text-overflow_no"
                    type="submit"
                  >
                    <i className="fa fa-search" />
                  </button>
                </span>
              </div>
            </div>
          </form>
        </div>
      </div>
    );
  }
}

SearchForm.contextTypes = {
  router: PropTypes.shape()
};

SearchForm.propTypes = {
  selectQueryParams: PropTypes.shape({
    content: PropTypes.string
  }).isRequired,
  changeQueryParams: PropTypes.func.isRequired,
  sendRequest: PropTypes.func.isRequired
};

const mapStateToProps = state => ({
  selectQueryParams: selectQueryParams(state, faqContentsSearchListRN)
});

const mapDispatchToProps = dispatch => ({
  changeQueryParams: queryParams =>
    dispatch(changeQueryParams(faqContentsSearchListRN, queryParams)),
  sendRequest: () => dispatch(sendRequest(faqContentsSearchListRN))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SearchForm);



// WEBPACK FOOTER //
// ./src/lauoyts/LayoutApp/Content/Help/ReferenceInformation/ContentSearch/SearchForm/SearchForm.js